// extracted by mini-css-extract-plugin
module.exports = {"notification-pane":"NotificationPane_notification-pane__ANo_e","notification-pane--dark":"NotificationPane_notification-pane--dark__y7pfK"};